import { createContext, useEffect, useState } from "react";
import topApi from "../../components/api/ToPApi";
import { Bank, BanksResponse, Classifier, ClassifierValue } from "../../models/interfaces";







type ContextProps = {

    classifiers: Classifier[];
    values: ClassifierValue[];
    isLoading: Boolean;

    loadClassifiers: () => Promise<void>;
    loadValues: (classifierId: number) => Promise<void>;

    addClassifier: (classifier: Classifier) => Promise<string>;
    updateClassifier: (classifier: Classifier) => Promise<string>;
    deleteClassifier: (classifierId: number) => Promise<string>;

    addValue: (classifierId: number, value: ClassifierValue) => Promise<string>;
    updateValue: (classifierId: number, value: ClassifierValue) => Promise<string>;
    deleteValue: (classifierId: number, valueCode: string) => Promise<string>;

    getFIs: () => Promise<Bank[]>;
    getFIByClassifier: (classifierId: number) => Promise<any[]>;
    assignClassifierToFi: (classifierId: number, fi: number) => Promise<string>;
    unassignClassifierFromFi: (classifierId: number, fi: number) => Promise<string>;

    getFIByClassifierValue: (classifierId: number, valueCode: string) => Promise<any[]>;
    assignClassifierValueToFi: (classifierId: number, fi: number, valueCode: string) => Promise<string>;
    unassignClassifierValueFromFi: (classifierId: number, fi: number, valueCode: string) => Promise<string>;


    setDefaultValue: (classifierId: number, valueCode: string) => Promise<string>;



};



export const ClassifierContext =
    createContext({} as ContextProps);



export const ClassifierProvider = ({ children }: any) => {


    const [classifiers, setClassifiers] = useState<Classifier[]>([]);

    const [values, setValues] = useState<ClassifierValue[]>([]);
    const [isLoading, setIsLoading] = useState<Boolean>(false);



    useEffect(() => {

        loadClassifiers();

    }, []);



    /**
     * GET classifiers
     */
    const loadClassifiers = async () => {

        const resp =
            await topApi.get('/classifier');

        if (resp.status === 200) {

            setClassifiers(resp.data.classifiers);

        }

    };



    /**
     * GET values
     */
    const loadValues = async (
        classifierId: number
    ) => {

        const resp =
            await topApi.get(

                `/classifier/values/${classifierId}`

            );

        if (resp.status === 200) {

            setValues(resp.data.classifierValue);

        }

    };



    /**
     * POST classifier
     */
    const addClassifier = async (
        classifier: Classifier
    ) => {

        try {

            await topApi.post(
                '/classifier',
                { classifier }
            );

            await loadClassifiers();

            return "success";

        } catch (e: any) {

            return e.response?.data?.error
                || "Error de comunicación";

        }

    };



    /**
     * PUT classifier
     */
    const updateClassifier = async (
        classifier: Classifier
    ) => {

        try {

            await topApi.put(

                `/classifier/${classifier.classifierId}`,
                { classifier }

            );

            await loadClassifiers();

            return "success";

        } catch (e: any) {

            return e.response?.data?.error
                || "Error de comunicación";

        }

    };



    /**
     * DELETE classifier
     */
    const deleteClassifier = async (
        classifierId: number
    ) => {

        try {

            await topApi.delete(

                `/classifier/${classifierId}`

            );

            setClassifiers(
                classifiers.filter(
                    c => c.classifierId !== classifierId
                )
            );

            return "success";

        } catch (e: any) {

            return e.response?.data?.error
                || "Error de comunicación";

        }

    };



    /**
     * POST value
     */
    const addValue = async (

        classifierId: number,
        value: ClassifierValue

    ) => {

        try {

            await topApi.post(

                `/classifier/values/${classifierId}`,
                { value }

            );

            await loadValues(classifierId);

            return "success";

        } catch (e: any) {

            return e.response?.data?.error
                || "Error de comunicación";

        }

    };



    /**
     * PUT value
     */
    const updateValue = async (

        classifierId: number,
        value: ClassifierValue

    ) => {

        try {

            await topApi.put(

                `/classifier/values/${classifierId}`,
                { value }

            );

            await loadValues(classifierId);

            return "success";

        } catch (e: any) {

            return e.response?.data?.error
                || "Error de comunicación";

        }

    };



    /**
     * DELETE value
     */
    const deleteValue = async (

        classifierId: number,
        valueCode: string

    ) => {

        try {

            await topApi.delete(

                `/classifier/values/${classifierId}/${valueCode}`

            );

            await loadValues(classifierId);

            return "success";

        } catch (e: any) {

            return e.response?.data?.error
                || "Error de comunicación";

        }

    };





    /**
     * setDefaultValue
     */
    const setDefaultValue = async (

        classifierId: number,
        valueCode: string

    ) => {

        try {

            await topApi.put(

                `/classifier/setDefaultValue/${classifierId}/${valueCode}`

            );

            await loadValues(classifierId);

            return "success";

        } catch (e: any) {

            return e.response?.data?.error
                || "Error de comunicación";

        }

    };

    const getFIs = async () => {

        const resp = await topApi.get<BanksResponse>('/bank/getBanks');
        if (resp.status == 200) {
            return resp.data.banks || [];
        }
    }

    /**
     * GET classifier FIs
     */
    const getFIByClassifier = async (
        classifierId: number
    ) => {

        const resp =
            await topApi.get(

                `/classifier/getClassifierFis/${classifierId}`

            );

        return resp.data.fis || [];

    };

    /**
     * setDefaultValue
     */
    const assignClassifierToFi = async (
        classifierId: number, fi: number
    ) => {
        try {
            await topApi.put(
                `/classifier/assignClassifierToFi/${classifierId}/${fi}`
            );
            return "success";
        } catch (e: any) {
            return e.response?.data?.error
                || "Error de comunicación";
        }

    };

    /**
     * setDefaultValue
     */
    const unassignClassifierFromFi = async (
        classifierId: number, fi: number
    ) => {
        try {
            await topApi.put(
                `/classifier/unassignClassifierFromFi/${classifierId}/${fi}`
            );
            return "success";
        } catch (e: any) {
            return e.response?.data?.error
                || "Error de comunicación";
        }

    };


    /**
     * GET classifier FIs
     */
    const getFIByClassifierValue = async (
        classifierId: number,
        valueCode: string
    ) => {

        const resp =
            await topApi.get(
                `/classifier/getClassifierValueFis/${classifierId}/${valueCode}`
            );

        return resp.data.fis || [];

    };

    /**
     * setDefaultValue
     */
    const assignClassifierValueToFi = async (
        classifierId: number, fi: number, valueCode: string
    ) => {
        try {
            await topApi.put(
                `/classifier/assignClassifierValueToFi/${classifierId}/${fi}/${valueCode}`
            );
            return "success";
        } catch (e: any) {
            return e.response?.data?.error
                || "Error de comunicación";
        }

    };

    /**
     * setDefaultValue
     */
    const unassignClassifierValueFromFi = async (
        classifierId: number, fi: number, valueCode: string
    ) => {
        try {
            await topApi.put(
                `/classifier/unassignClassifierValueFromFi/${classifierId}/${fi}/${valueCode}`
            );
            return "success";
        } catch (e: any) {
            return e.response?.data?.error
                || "Error de comunicación";
        }

    };




    return (

        <ClassifierContext.Provider

            value={{

                classifiers,
                values,

                loadClassifiers,
                loadValues,

                addClassifier,
                updateClassifier,
                deleteClassifier,

                addValue,
                updateValue,
                deleteValue,

                setDefaultValue,
                getFIs,
                getFIByClassifier,
                assignClassifierToFi,
                unassignClassifierFromFi,

                getFIByClassifierValue,
                assignClassifierValueToFi,
                unassignClassifierValueFromFi,
                isLoading

            }}

        >

            {children}

        </ClassifierContext.Provider>

    );

};